import { render } from "./SportFacilitiesModule.vue?vue&type=template&id=e156b4a4&scoped=true"
import script from "./SportFacilitiesModule.vue?vue&type=script&lang=js"
export * from "./SportFacilitiesModule.vue?vue&type=script&lang=js"

import "./SportFacilitiesModule.vue?vue&type=style&index=0&id=e156b4a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e156b4a4"

export default script